// extracted by mini-css-extract-plugin
module.exports = {"vbarCard":"vbar-card_vbarCard__HU9pw","cardButtons":"vbar-card_cardButtons__MR6VG","acceptButton":"vbar-card_acceptButton__X8tmg","dismissButton":"vbar-card_dismissButton__gkYyV"};